import React, { useState } from 'react';

const PALETTE = ['#EFEDE3', '#E2E8E5', '#EBE3E0', '#E0E5EB', '#EDE7E2', '#E6EBE0'];

function colorFor(seed) {
  if (!seed) return PALETTE[0];
  let hash = 0;
  for (let i = 0; i < seed.length; i++) hash = (hash * 31 + seed.charCodeAt(i)) & 0xff;
  return PALETTE[hash % PALETTE.length];
}

export default function Avatar({ initials, seed, size = 28, title }) {
  const [hover, setHover] = useState(false);

  return (
    <span
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{ position: 'relative', display: 'inline-flex' }}
    >
      <span
        className="inline-flex items-center justify-center rounded-full font-medium"
        style={{
          width: size,
          height: size,
          background: colorFor(seed || initials),
          color: '#3A3A38',
          fontSize: Math.round(size * 0.4),
          border: '1.5px solid #fff',
          boxSizing: 'content-box'
        }}
      >
        {initials || '?'}
      </span>
      {hover && title && (
        <span
          role="tooltip"
          style={{
            position: 'absolute',
            bottom: 'calc(100% + 6px)',
            left: '50%',
            transform: 'translateX(-50%)',
            background: '#1A1A1A',
            color: '#fff',
            fontSize: 11,
            fontWeight: 500,
            padding: '4px 8px',
            borderRadius: 4,
            whiteSpace: 'nowrap',
            pointerEvents: 'none',
            zIndex: 20,
            boxShadow: '0 2px 6px rgba(0,0,0,0.18)'
          }}
        >
          {title}
        </span>
      )}
    </span>
  );
}
